export default __webpack_public_path__ + "static/media/programme2.8f4045fd.webp";